import React, { useState } from "react";

type FallbackImageProps = React.ImgHTMLAttributes<HTMLImageElement> & {
	src: string;
	alt?: string;
	className?: string;
	// optional fallback image path (we hard-code a default one)
	fallbackSrc?: string;
	// whether to use a large image placeholder or small (default)
	useLarge?: boolean;
	style?: string;
};

const FallbackImage: React.FC<FallbackImageProps> = ({
	fallbackSrc,
	style,
	src,
	alt,
	className,
	useLarge = false,
	...props
}) => {
	const [imgSrc, setImgSrc] = useState(src);
	const [altSrc, setAltSrc] = useState(alt);

	const handleError = () => {
		// Prevent infinite loop if fallback also fails
		setOnError(null);

		// Fallback image path
		const defaultFallback = useLarge
			? "/img/placeholder-lg.jpg"
			: "/img/placeholder-sm.jpg";
		setImgSrc(
			fallbackSrc ? fallbackSrc : process.env.PUBLIC_URL + defaultFallback
		);

		// Fallback alt text
		setAltSrc("Image not available");
	};

	const [onError, setOnError] =
		useState<React.ReactEventHandler<HTMLImageElement> | null>(
			() => handleError
		);

	return (
		<img
			src={imgSrc}
			alt={altSrc}
			className={className}
			onError={onError}
			style={style}
			{...props}
		/>
	);
};

export default FallbackImage;
